export const environment = {
  production: true,
  buildId: '2543465152717641',
  configFile: 'config.json',
};
